module.exports = __webpack_public_path__ + "img/resp-web.6142b177.svg";